import { render } from "./MaintenancePlan.vue?vue&type=template&id=124a76f7"
import script from "./MaintenancePlan.vue?vue&type=script&lang=js"
export * from "./MaintenancePlan.vue?vue&type=script&lang=js"

import "./MaintenancePlan.vue?vue&type=style&index=0&id=124a76f7&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__